import { render } from "./RangeSlider.vue?vue&type=template&id=2a8d6e34"
import script from "./RangeSlider.vue?vue&type=script&lang=js"
export * from "./RangeSlider.vue?vue&type=script&lang=js"

import "./RangeSlider.vue?vue&type=style&index=0&id=2a8d6e34&lang=css"
script.render = render

export default script